/* -- Cover the "Powered by tagembed" badge on the Google review widget --
      That badge is re-rendered by the tagembed embed script itself (with
      !important inline styles), so CSS alone can't reliably hide it - it
      just comes back on the next render. Instead we lay a solid white div
      on top of it, kept in sync with its real on-screen box.

      IMPORTANT: target the badge's own <a href="...tagembed.com..."> link,
      not a positional selector like ".tb_app_container > div" - the badge
      row isn't always the first child (it can be injected after the review
      feed), so a positional match can grab the ENTIRE review feed instead
      and paint white over all of it. A sane max-size guard below is a
      second line of defense in case the widget's markup changes again. */
(function () {
  var MAX_BADGE_WIDTH = 400;
  var MAX_BADGE_HEIGHT = 120;

  /** @type {HTMLDivElement | null} */
  var cover = null;
  var rafPending = false;

  function findBadgeLink() {
    return document.querySelector('.tb_app_container a[href*="tagembed.com"]');
  }

  function ensureCover() {
    if (cover) return cover;
    cover = document.createElement('div');
    cover.className = 'tov-tagembed-cover';
    cover.style.position = 'absolute';
    cover.style.background = '#ffffff';
    cover.style.zIndex = '2147483647';
    cover.style.pointerEvents = 'none';
    cover.style.display = 'none';
    document.body.appendChild(cover);
    return cover;
  }

  function position() {
    rafPending = false;
    var link = findBadgeLink();
    var el = ensureCover();

    if (!link) {
      el.style.display = 'none';
      return;
    }

    var rect = link.getBoundingClientRect();

    /* Refuse to cover anything bigger than a badge - protects against
       ever again painting white over real widget content. */
    if (
      rect.width === 0 ||
      rect.height === 0 ||
      rect.width > MAX_BADGE_WIDTH ||
      rect.height > MAX_BADGE_HEIGHT
    ) {
      el.style.display = 'none';
      return;
    }

    el.style.display = 'block';
    el.style.top = (rect.top + window.scrollY) + 'px';
    el.style.left = (rect.left + window.scrollX) + 'px';
    el.style.width = rect.width + 'px';
    el.style.height = rect.height + 'px';
  }

  function schedulePosition() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(position);
  }

  schedulePosition();
  window.addEventListener('resize', schedulePosition);
  window.addEventListener('scroll', schedulePosition, true);

  /* The embed script re-renders its content async, so keep watching
     rather than checking once and disconnecting. */
  new MutationObserver(schedulePosition).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* -- Sticky header shadow on scroll -- */
(function () {
  var header = document.getElementById('main-header');
  if (!header) return;
  window.addEventListener('scroll', function () {
    header.classList.toggle('scrolled', window.scrollY > 10);
  });
})();

/* -- Search overlay + live suggestions (Shopify Predictive Search API) -- */
(function () {
  var trigger     = document.getElementById('search-trigger');
  var overlay     = document.getElementById('search-overlay');
  var closeBtn    = document.getElementById('search-close');
  var input       = document.getElementById('search-input');
  var suggestions = document.getElementById('search-suggestions');
  if (!trigger || !overlay) return;

  var MAX_RESULTS = 5;
  var activeIndex = -1;
  var debounceTimer = null;
  var currentQuery = '';

  /* Escape regex special chars so user input is matched literally */
  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /* Wrap matched text in <mark> for highlighting */
  function highlight(text, query) {
    var re = new RegExp('(' + escapeRegex(query) + ')', 'gi');
    return text.replace(re, '<mark>$1</mark>');
  }

  function getItems() {
    return Array.from(suggestions.querySelectorAll('.suggestion-item'));
  }

  function setActive(index) {
    var items = getItems();
    items.forEach(function (el, i) { el.classList.toggle('active', i === index); });
    activeIndex = index;
  }

  function hideSuggestions() {
    suggestions.classList.remove('visible');
    suggestions.innerHTML = '';
    activeIndex = -1;
  }

  function renderResults(products, query) {
    var q = query.trim();
    suggestions.innerHTML = '';
    activeIndex = -1;

    if (!products.length) {
      suggestions.innerHTML = '<p class="suggestions-empty">No products found for "<strong>' + q + '</strong>"</p>';
      suggestions.classList.add('visible');
      return;
    }

    var label = document.createElement('p');
    label.className = 'suggestions-label';
    label.textContent = 'Products';
    suggestions.appendChild(label);

    products.slice(0, MAX_RESULTS).forEach(function (product) {
      var imgSrc = (product.featured_image && product.featured_image.url) ? product.featured_image.url : '';

      /*
        /search/suggest.json returns prices as decimal strings in the store's
        currency unit (e.g. "500.00"), NOT in cents.
        Flat fields price_min and price_max give the per-variant price bounds.
      */
      var priceText = '';
      var minAmt = product.price_min != null ? Math.round(parseFloat(product.price_min)) : null;
      var maxAmt = product.price_max != null ? Math.round(parseFloat(product.price_max)) : null;
      if (minAmt !== null && maxAmt !== null && maxAmt > minAmt) {
        priceText = 'Rs ' + minAmt.toLocaleString('en-PK') + ' – Rs ' + maxAmt.toLocaleString('en-PK');
      } else if (minAmt !== null) {
        priceText = 'Rs ' + minAmt.toLocaleString('en-PK');
      } else if (product.price != null) {
        priceText = 'Rs ' + Math.round(parseFloat(product.price)).toLocaleString('en-PK');
      }

      var category = product.product_type || product.vendor || '';

      var item = document.createElement('div');
      item.className = 'suggestion-item';
      item.setAttribute('role', 'option');
      item.dataset.url = product.url;
      item.innerHTML =
        '<div class="suggestion-item-img">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy"/>' : '') +
        '</div>' +
        '<div class="suggestion-item-info">' +
          '<div class="suggestion-item-name">' + highlight(product.title, q) + '</div>' +
          '<div class="suggestion-item-cat">' + category + '</div>' +
        '</div>' +
        '<div class="suggestion-item-price">' + priceText + '</div>';

      /* mousedown (not click) keeps focus on the input; then navigate to product */
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        window.location.href = product.url;
      });

      suggestions.appendChild(item);
    });

    /*
      "See all results" footer.
      BUG 2 FIX: removed the <span class="material-symbols-outlined">search</span> icon
      that was here. The CSS rule `.search-input-wrap .material-symbols-outlined` applied
      position:absolute;right:16px to it, making it bleed over each suggestion row's
      right column. The link text is self-explanatory without the icon.
    */
    var searchUrl = (window.__searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
    var footer = document.createElement('div');
    footer.className = 'suggestions-footer';
    footer.innerHTML = '<a href="' + searchUrl + '">See all results for "' + q + '"</a>';
    suggestions.appendChild(footer);

    suggestions.classList.add('visible');
  }

  function fetchSuggestions(query) {
    var q = query.trim();
    if (!q) { hideSuggestions(); return; }
    currentQuery = q;

    try {
      fetch(
        '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=5' +
        '&resources[options][fields]=title,product_type,vendor'
      )
        .then(function (res) { return res.json(); })
        .then(function (data) {
          /* Guard: discard response if user has already typed something newer */
          if (q !== currentQuery) return;
          var products = data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products;
          if (!Array.isArray(products)) { hideSuggestions(); return; }
          renderResults(products, q);
        })
        .catch(function () { hideSuggestions(); });
    } catch (err) {
      hideSuggestions();
    }
  }

  /* -- Open / close overlay -- */
  function openSearch() {
    overlay.classList.add('open');
    if (input) input.focus();
  }
  function closeSearch() {
    overlay.classList.remove('open');
    hideSuggestions();
    if (input) input.value = '';
  }

  trigger.addEventListener('click', function () {
    overlay.classList.contains('open') ? closeSearch() : openSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  /* -- Live input with 250ms debounce -- */
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchSuggestions(input.value);
      }, 250);
    });

    /* -- Keyboard navigation -- */
    input.addEventListener('keydown', function (e) {
      var items = getItems();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(Math.min(activeIndex + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault();
          window.location.href = items[activeIndex].dataset.url;
        }
        /* else: let form submit normally to routes.search_url */
      } else if (e.key === 'Escape') {
        if (suggestions.classList.contains('visible')) {
          hideSuggestions();
        } else {
          closeSearch();
        }
      }
    });
  }

  /* Close suggestions when clicking outside the overlay */
  document.addEventListener('click', function (e) {
    if (!overlay.contains(e.target)) hideSuggestions();
  });
})();

/* -- Mobile nav drawer -- */
(function () {
  var overlay  = document.getElementById('mobile-nav-overlay');
  var backdrop = document.getElementById('mobile-nav-backdrop');
  var openBtn  = document.getElementById('mobile-menu-btn');
  var closeBtn = document.getElementById('mobile-nav-close');
  if (!overlay || !openBtn) return;

  function openNav() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (backdrop) backdrop.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* Accordion for nested nav items */
  var toggles = overlay.querySelectorAll('.mobile-nav-toggle');
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var parent = btn.closest('.mobile-nav-parent');
      if (!parent) return;
      var expanded = parent.getAttribute('aria-expanded') === 'true';
      parent.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });
})();

/* -- Cart sidebar -- */
(function () {
  var cart        = document.getElementById('side-cart');
  var backdrop    = document.getElementById('cart-backdrop');
  var openBtn     = document.getElementById('open-cart-btn');
  var closeBtn    = document.getElementById('close-cart');
  var continueBtn = document.getElementById('continue-shopping');
  if (!cart || !openBtn) return;

  function openCart() {
    cart.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cart.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* Expose so product.js / product-card.js can open the drawer */
  window.openCart = openCart;

  openBtn.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (continueBtn) continueBtn.addEventListener('click', closeCart);
  if (backdrop) backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });
})();

/* -- Cart Ajax: optimistic qty change & remove -- */
(function () {
  var cartItemsList = document.getElementById('cart-items-list');
  var cartCount     = document.getElementById('cart-count');
  var basketCount   = document.getElementById('basket-count');
  var cartSubtotal  = document.getElementById('cart-subtotal-amount');
  if (!cartItemsList) return;

  function formatMoney(cents) {
    return 'Rs ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
  }

  /* ── Toast for rollback feedback ── */
  function showToast(msg) {
    var old = document.getElementById('tov-cart-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.id = 'tov-cart-toast';
    el.className = 'tov-cart-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('tov-cart-toast--in'); });
    setTimeout(function () {
      el.classList.remove('tov-cart-toast--in');
      setTimeout(function () { el.remove(); }, 300);
    }, 3000);
  }

  /* ── Recompute subtotal + badge from current DOM ── */
  function recalcTotals() {
    var items = cartItemsList.querySelectorAll('.cart-item');
    var totalCents = 0;
    var totalCount = 0;
    items.forEach(function (item) {
      if (item.classList.contains('cart-item--gone')) return;
      var qty       = parseInt((item.querySelector('.qty-value') || {}).textContent, 10) || 0;
      var unitPrice = parseInt(item.dataset.unitPrice, 10) || 0;
      totalCents += qty * unitPrice;
      totalCount += qty;
    });
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(totalCents);
    if (cartCount) {
      cartCount.textContent = totalCount;
      cartCount.style.display = totalCount > 0 ? '' : 'none';
    }
    if (basketCount) basketCount.textContent = '(' + totalCount + ')';
  }

  /* ── Per-item debounce state ──
     Approach: debounce (400 ms).
     Every click instantly mutates the DOM; the actual POST fires only after
     400 ms of silence on that item key. Rapid clicking sends one request
     (the final quantity) rather than flooding the server with intermediate
     values. AbortController is not needed — we just overwrite the timer. */
  var debounceTimers = {};
  var pendingQty     = {};

  /* ── Optimistic update ── */
  function optimisticSetQty(itemEl, newQty) {
    var key       = itemEl.dataset.key;
    var unitPrice = parseInt(itemEl.dataset.unitPrice, 10) || 0;

    if (newQty <= 0) {
      itemEl.classList.add('cart-item--gone');
      recalcTotals();
      /* If every item is gone, show empty state immediately */
      var remaining = cartItemsList.querySelectorAll('.cart-item:not(.cart-item--gone)');
      if (remaining.length === 0) {
        /* Keep the gone elements in the DOM for potential rollback — hide visually */
        var emptyDiv = cartItemsList.querySelector('.cart-empty-optimistic');
        if (!emptyDiv) {
          emptyDiv = document.createElement('div');
          emptyDiv.className = 'cart-empty-optimistic cart-empty';
          emptyDiv.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
            '<p>Your basket is empty</p>' +
            '<a href="/collections/all">Start shopping</a>';
          cartItemsList.appendChild(emptyDiv);
        }
      }
    } else {
      /* Instant qty and price update */
      var qtyEl    = itemEl.querySelector('.qty-value');
      var priceEl  = itemEl.querySelector('.cart-item-price');
      var minusBtn = itemEl.querySelector('.qty-minus');
      var plusBtn  = itemEl.querySelector('.qty-plus');
      if (qtyEl)    qtyEl.textContent    = newQty;
      if (priceEl)  priceEl.textContent  = formatMoney(newQty * unitPrice);
      if (minusBtn) minusBtn.dataset.qty = newQty - 1;
      if (plusBtn)  plusBtn.dataset.qty  = newQty + 1;
      recalcTotals();
    }

    /* Schedule the debounced POST */
    pendingQty[key] = newQty;
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(function () {
      delete debounceTimers[key];
      var qty = pendingQty[key];
      delete pendingQty[key];
      syncQty(key, qty, itemEl, newQty);
    }, 400);
  }

  /* ── Background sync ── */
  function syncQty(key, qty, itemEl, optimisticQty) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-change-' + res.status);
        return res.json();
      })
      .then(function (cart) {
        /* Silent reconciliation: server may have capped qty (stock limit) */
        var serverItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { serverItem = cart.items[i]; break; }
        }
        var serverQty = serverItem ? serverItem.quantity : 0;
        if (serverQty !== optimisticQty) {
          /* Quietly correct to actual server state */
          refreshCart();
        }
      })
      .catch(function () {
        showToast("Couldn't update quantity — try again");
        refreshCart(); /* rollback to true server state */
      });
  }

  /* ── Full refresh (add-to-cart, reconciliation, rollback) ── */
  function renderCartHtml(cart) {
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? '' : 'none';
    }
    if (basketCount) basketCount.textContent = '(' + cart.item_count + ')';
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      cartItemsList.innerHTML =
        '<div class="cart-empty">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p>Your basket is empty</p>' +
          '<a href="/collections/all">Start shopping</a>' +
        '</div>';
    } else {
      var html = '';
      cart.items.forEach(function (item) {
        var imgSrc = item.featured_image && item.featured_image.url
          ? item.featured_image.url : '';
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-item-variant">' + item.variant_title + '</p>'
          : '<p class="cart-item-variant"></p>';
        html +=
          '<div class="cart-item" data-key="' + item.key + '" data-unit-price="' + item.price + '">' +
            '<div class="cart-item-img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="cart-item-info">' +
              '<div class="cart-item-top">' +
                '<span class="cart-item-name">' + item.product_title + '</span>' +
                '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              variantLine +
              '<div class="cart-item-bottom">' +
                '<div class="qty-control">' +
                  '<button class="qty-btn qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">' +
                    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="M5 12h14"/></svg>' +
                  '</button>' +
                  '<span class="qty-value">' + item.quantity + '</span>' +
                  '<button class="qty-btn qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">' +
                    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
                  '</button>' +
                '</div>' +
                '<button class="cart-item-remove" data-key="' + item.key + '">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      cartItemsList.innerHTML = html;
    }
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCartHtml);
  }

  /* ── Single delegated listener on the stable parent ──
     cartItemsList itself is never replaced (only its innerHTML is), so one
     listener registered here handles all current and future child buttons. */
  cartItemsList.addEventListener('click', function (e) {
    var plusBtn   = e.target.closest('.qty-plus');
    var minusBtn  = e.target.closest('.qty-minus');
    var removeBtn = e.target.closest('.cart-item-remove');
    if (!plusBtn && !minusBtn && !removeBtn) return;

    var itemEl = e.target.closest('.cart-item');
    if (!itemEl || itemEl.classList.contains('cart-item--gone')) return;

    if (removeBtn) { optimisticSetQty(itemEl, 0); return; }

    var currentQty = parseInt((itemEl.querySelector('.qty-value') || {}).textContent, 10) || 0;
    optimisticSetQty(itemEl, plusBtn ? currentQty + 1 : currentQty - 1);
  });

  /* -- Shared globals -- */
  window.refreshCart = refreshCart;

  window.tovAddToCart = function (variantId, qty, btn, options) {
    var openDrawer = !options || options.openDrawer !== false;
    var originalText = btn ? btn.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (btn) btn.textContent = 'Added!';
        refreshCart();
        if (openDrawer && typeof window.openCart === 'function') window.openCart();
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = originalText; }
        }, 1500);
        return data;
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        throw err;
      });
  };

})();
